import { getCards} from "@/api/cards";

const getDefaultState = () => {
    return {
        cards: [],
        cardsLoading: true,

        pagination: {
            pageList: {
              active: false,
              pages: []
            },
            currentPage: 1,
            lastPage: 0
        },
    }
}

export default {
    namespaced: true,
    state: getDefaultState(),
    actions: {
        getCards({ commit, state }, params, perPage= 10, currentPage = 1) {
            const sort = params?.sort || "id"
            const search = params?.search || ""
            commit("SET_CARDS_LOADING", true);
            currentPage = state.pagination.currentPage
            getCards(perPage, currentPage, sort, search)
                .then(res => {
                    commit("SET_CARDS", res.data)
                })
                .finally(() => commit("SET_CARDS_LOADING", false));
        },
        clearData({ commit }) {
            commit("INIT_STATE");
        },

        // pagination
        getCardsListPage ({ commit, dispatch }, params) {
            commit('SET_CURRENT_PAGE', params.page)
            dispatch('getCards', params)
        },
    },
    mutations: {
        SET_CARDS(state, cards) {
            state.cards = cards
        },
        ADD_CARD(state, card) {
            state.cards.push(card)
        },
        SET_CARDS_LOADING(state, loading) {
            state.cardsLoading = loading
        },
        INIT_STATE(state) {
            Object.assign(state, getDefaultState());
        },
        RESET_CARDS_LIST_CURRENT_PAGE: (state) => {
            state.pagination.currentPage = 1
        },
        SET_CURRENT_PAGE: (state, pageNum) => {
            state.pagination.currentPage = pageNum
        },
    }
}